export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12587.c7ff00d2.jpg";